module.exports = __webpack_public_path__ + "img/companycoverlogo-white.7e4ab634.png";